import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter, Input,
  OnChanges,
  Output, SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {CanvasService} from 'src/app/core/services/canvas.service';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {SelectedCertInterface} from '../sign-flow-document.component';
import {ContentPosition, SignatureConfig} from '../signature-config.model';
import * as htmlToImage from 'html-to-image';
import {MatDialog} from '@angular/material';
import * as _ from 'lodash';
import {delay} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {CommonService} from '../../../../../../../core/services/common.service';
import {CanvasComponent} from 'src/app/shared/components/canvas/canvas.component';
import {ImageGenerateService} from "../../../../../../../core/services/image-generate.service";
import {TranslateService} from "@ngx-translate/core";
import {DomSanitizer} from "@angular/platform-browser";
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
export const imageConfigFormPreviewId = 'image-config_form_preview';
export const imageConfigViewScaleId = 'image-config_scale';
export const imageConfigRenderId = 'imageConfigContainer';

@Component({
  selector: 'app-image-sign-config',
  templateUrl: './image-sign-config.component.html',
  styleUrls: ['./image-sign-config.component.scss']
})
export class ImageSignConfigComponent implements OnChanges, AfterViewInit {
  @Input() enterpriseName: string;
  @Input() selectedCert: SelectedCertInterface;
  @Input() signConfig: SignatureConfig;
  @Input() signMethod;
  @Input() scopeType: number;
  @Input() domRenderImage: HTMLDivElement;
  userType: string = localStorage.getItem('userType');
  @Input() isHiddenLabel: boolean = false;
  @Input() generationId: number = 0;  // captures tab state; skip result if changed

  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;

  signConfigClone: SignatureConfig;
  @Input() public canvasWidth = 300;
  @Input() public canvasHeight = 300;
  public indexSelect = 0;

  nameImageSignatureControl = new FormControl();
  isSizeFileError = false;
  isFormatFileError = false;
  enterpriseTypes = EnterpriseTypes;
  @Input() widthImageSignature = 0;
  @Input() heightImageSignature = 0;
  @Output() eventConfirmChangeSignatureImage = new EventEmitter();
  @Output() eventIsSetUpConfig= new EventEmitter();
  @Input() defaultImageConfigs: any = null;
  @Input() isSetUpConfig: boolean = false;

  fontFamily: any = [
    {name: 'Roboto', value: 'Roboto'}
  ];
  signaturePosition: any = [
    {name: 'enterprise_contract.image_signing.no_image.top', value: 'top'},
    {name: 'enterprise_contract.image_signing.no_image.bottom', value: 'bottom'},
    {name: 'enterprise_contract.image_signing.no_image.left', value: 'left'},
    {name: 'enterprise_contract.image_signing.no_image.right', value: 'right'}
  ];
  signRatio: any = [
    // {name: 'enterprise_contract.image_signing.no_image.10', value: '10:90'},
    // {name: 'enterprise_contract.image_signing.no_image.20', value: '20:80'},
    {name: 'enterprise_contract.image_signing.no_image.30', value: '30:70'},
    {name: 'enterprise_contract.image_signing.no_image.40', value: '40:60'},
    {name: 'enterprise_contract.image_signing.no_image.50', value: '50:50'},
    {name: 'enterprise_contract.image_signing.no_image.60', value: '60:40'},
    {name: 'enterprise_contract.image_signing.no_image.70', value: '70:30'},
    // {name: 'enterprise_contract.image_signing.no_image.80', value: '80:20'},
    // {name: 'enterprise_contract.image_signing.no_image.90', value: '90:10'},
  ];
  contentPosition  = [
    {name: 'enterprise_contract.image_signing.no_image.start', value: ContentPosition.left},
    {name: 'enterprise_contract.image_signing.no_image.center', value: ContentPosition.center},
    {name: 'enterprise_contract.image_signing.no_image.end', value: ContentPosition.right}
  ]

  constructor(
    private cd: ChangeDetectorRef,
    private canvasService: CanvasService,
    private dialog: MatDialog,
    private signDocumentService: SignDocumentService,
    private commonService: CommonService,
    private imageGenerateService: ImageGenerateService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    public message: Message,
  ) {
  }

  updateView() {
    this.setFontSize(imageConfigFormPreviewId);
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['enterpriseName']) {
    //   if(localStorage.getItem('userType') != '5' ){
    //     this.signConfig.enterpriseName.value = localStorage.getItem('userName')
    //   }
    //   this.signConfig.enterpriseName.value = this.enterpriseName;
    // }

    if (changes.selectedCert && this.selectedCert) {
      // this.signConfig.confirmBy.value = this.selectedCert.issuedTo;
    }

    if (changes.signConfig && this.signConfig) {
      this.signConfigClone = _.cloneDeep(this.signConfig);
      this.signDocumentService.setFontSize(imageConfigViewScaleId);
    }
  }

  ngAfterViewInit() {
    this.setFontSize(imageConfigViewScaleId);
  }

  onCheckboxChange(input?: HTMLInputElement) {

    this.cd.detectChanges();

    if (input) {
      input.focus();
    }

    setTimeout(() => {
      this.setFontSize(imageConfigFormPreviewId);
      this.cd.detectChanges();
    }, 100);
  }

  onCheckboxSignatureImageChange() {
    this.cd.detectChanges();

    if (!this.signConfigClone.signatureImage.enabled) {
      this.signConfigClone.signaturePosition.value = 'left';
      this.signConfigClone.signatureRatio.value = this.signConfigClone.signatureRatio.value ? this.signConfigClone.signatureRatio.value : '30:70';
    } else {
      this.signConfigClone.signaturePosition.value = '';
      this.signConfigClone.signatureRatio.value = '';
    }

    setTimeout(() => {
      this.setFontSize(imageConfigFormPreviewId);
    }, 100);
  }

  onOpenDialog(tmpl: TemplateRef<any>) {
    if (this.signConfig) {
      this.signConfigClone = _.cloneDeep(this.signConfig);
      if(this.defaultImageConfigs && !this.isSetUpConfig){
        this.enableConfig();
      }
      this.dialog.open(tmpl, {width: '60%'});
      setTimeout(() => {
        this.setFontSize(imageConfigFormPreviewId);
        if (this.signConfigClone.signatureImage.enabled) {
          if (this.signConfigClone.isDraw.enabled) {
            this.indexSelect = 2;
            this.canvasService.setIsSelectSignDraw(true);
          } else {
            this.indexSelect = 0;
          }
        } else {
          this.indexSelect = 0;
        }
      }, 200);
      // this.dialog.afterOpened.pipe(delay(200)).subscribe(() => {
      //   this.setFontSize(imageConfigFormPreviewId);
      // });
    }
  }

  onCloseDialog() {
    this.signConfigClone = {...this.signConfig};
    // console.log(this.signConfig);
    // console.log(this.signConfigClone);
    this.dialog.closeAll();
  }

  confirm() {
    if(this.checkErrorConfigDefault()){
      return
    }
    this.signConfig = Object.assign(this.signConfig, this.signConfigClone);
    if (!this.signConfig.address.enabled) {
      this.signConfig.address.value = null;
    }

    if (!this.signConfig.position.enabled) {
      this.signConfig.position.value = null;
    }

    this.dialog.closeAll();

    this.eventConfirmChangeSignatureImage.emit();
    this.eventIsSetUpConfig.emit();
    this.cd.detectChanges();
    setTimeout(() => {
      this.setFontSize(imageConfigViewScaleId);
      this.setFontSize(imageConfigRenderId);
    }, 100);

  }

  allValid(obj: SignatureConfig = this.signConfig): 'non-check' | boolean {
    let countEnabled = 0;
    for (const key in obj) {
      if (obj[key].enabled && key !== 'confirmBy') {
        countEnabled++;
      }
    }

    if (!countEnabled) {
      return 'non-check';
    }

    const position = obj.position;
    const address = obj.address;
    const signatureImageBase64 = obj.signatureImageBase64;
    const signatureImage = obj.signatureImage;

    if (position.enabled && !position.value) {
      return false;
    }

    if (signatureImage.enabled && !signatureImageBase64.value) {
      return false;
    }

    return !(address.enabled && !address.value);
  }

  disableConfirmBtn() {
    return this.allValid(this.signConfigClone) !== true;
  }

  async renderImage() {
    // bắt đầu gọi lên server để gen ảnh
    const callGenerationId = this.generationId;  // capture tab state at start
    try {
      const imageSize = this.setSizeFrameImage();
      const rs = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();

      // Skip if tab changed while waiting for response
      if (callGenerationId !== this.generationId) return;

      const file = new File([rs], 'signatureImage.png', {type: 'image/png'});
      this.canvasService.setCanvasImage(file);
      this.commonService.getBase64(file).then(r => {
        if (callGenerationId !== this.generationId) return;
        this.canvasService.setCanvasImageUrl(r as string);
      });
    } catch (e) {
      console.log("call api error, use html to image", e);

      // Skip if tab changed while waiting for response
      if (callGenerationId !== this.generationId) return;

      const imageFile = await htmlToImage.toBlob(this.domRenderImage);

      if (callGenerationId !== this.generationId) return;

      const file = new File([imageFile], 'signatureImage.png', { type: 'image/png' });
      this.canvasService.setCanvasImage(file);

      const imgUrl = await htmlToImage.toPng(this.domRenderImage);
      this.canvasService.setCanvasImageUrl(imgUrl);

    }
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfigClone);
  }

  showConfig(key: string): boolean {
    if (key === 'greenTick') {
      return false;
    }

    if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_OTP) {
      if (key === 'phoneNumber') {
        return false;
      }

      if (key === 'confirmBy') {
        return false;
      }

      if (key === 'signatureImage') {
        return false;
      }

      if (key === 'isDraw') {
        return false;
      }
    } else {
      if (key === 'confirmBy' && this.scopeType !== 2) {
        return true;
      } else if (key === 'confirmBy' && this.scopeType === 2) {
        return false;
      }

      if (key === 'signatureImage') {
        return false;
      }

      if (key === 'isDraw') {
        return false;
      }
    }

    return this.signConfigClone[key].enabled;
  }

  showConfigPhone() {
    return this.selectedCert.typeCertificate == this.signMethod.SIGN_OTP;
  }

  onSelectDrawSign() {
    // this.disableBtnDeleteCanvas = true;
    // this.commonService.configCanvas(this.canvas.nativeElement, this.cx, this.canvasWidth, this.canvasHeight);
    this.canvasService.setIsSelectSignDraw(true);
  }

  nzSelectChange(index = 0) {
    const indexUploadTab = 1;
    const indexDrawTab = 2;
    if (index === indexDrawTab) {
      // this.isSelectDrawImage = true;
      // this.isRenderImage = false;
      // this.isDisableNextButton = true;
      this.canvasService.setIsDisableBtnDeleteCanvas(true);
      // this.systemImageSign = false;
    }
    if (index === indexUploadTab) {
      this.canvasService.setIsDisableBtnDeleteCanvas(true);
      // this.isSelectDrawImage = false;
      // this.isRenderImage = false;
      // this.isDisableNextButton = true;
      // this.fileUpload = null;
      // this.avatarUrl = null;
      // this.systemImageSign = false;
    }
  }

  onSelectedUpload($event: any) {
    // console.log($event.target.files);
    if ($event.target.files.length) {
      if ($event.target.files[0].size / 1024 / 1024 <= 2 && ($event.target.files[0].type.split('/')[1] === 'png' || $event.target.files[0].type.split('/')[1] === 'jpg' || $event.target.files[0].type.split('/')[1] === 'jpeg')) {
        this.resizeImage($event.target.files[0])
          .then(resizedImage => {
            this.signConfigClone.isDraw.enabled = false;
            this.signConfigClone.signatureImage.enabled = true;
            this.signConfigClone.signatureImageBase64.value = resizedImage as any;
            const img = new Image();
            img.src = resizedImage as any;
            img.onload = () => {
              this.widthImageSignature = img.width;
              this.heightImageSignature = img.height;
            };
            setTimeout(() => {
              this.setFontSize(imageConfigFormPreviewId);
            }, 100);
          })
          .catch(error => console.error("Error resizing image:", error));
        this.signConfigClone.signatureImageName.value = $event.target.files[0].name;
        this.isSizeFileError = false;
        this.isFormatFileError = false;
      } else {
        if ($event.target.files[0].size / 1024 / 1024 > 2) {
          this.isSizeFileError = true;
        }
        if ($event.target.files[0].type.split('/')[1] !== 'png' || $event.target.files[0].type.split('/')[1] !== 'jpg' || $event.target.files[0].type.split('/')[1] !== 'jpeg') {
          this.isFormatFileError = true;
        }
      }
    }
  }

  async resizeImage(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;
          while (height < 508) {
            width += img.width;
            height += img.height;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          const resizedDataURL = canvas.toDataURL("image/png", 0.8); // Specify image type and quality (0-1)
          resolve(resizedDataURL);
        };
        img.src = (event.target as any).result as any;
      };
      reader.onerror = (error) => reject(error);
    });
  }

  deleteImageSignature() {
    this.nameImageSignatureControl.reset();
    this.signConfigClone.signatureImageBase64.value = '';
    this.signConfigClone.signatureImageName.value = '';
    this.setFontSize(imageConfigFormPreviewId);
  }

  selectFontStyle() {
    this.signConfigClone.fontStyle.value = this.signConfigClone.fontStyle.value ? '' : 'italic';
    this.setFontSize(imageConfigFormPreviewId);
  }

  selectFontWeight() {
    this.signConfigClone.fontWeight.value = this.signConfigClone.fontWeight.value ? '' : 'bold';
    this.setFontSize(imageConfigFormPreviewId);
  }

  onChangeFont(event) {
    // //const nodeOther = document.getElementById(`sign-${enterpriseId}-approver-${userId}`);
    // const objSignature = this.listSignature.find(element => element.id == item.id); //lay chan ky thu i
    // const nodeOther = document.getElementById(`${objSignature.id}`);
    // if (nodeOther) {
    //   nodeOther.style.fontFamily = event.value;
    // }
    // //them thuoc tinh vao param
    // this.listSignature.forEach(item => {
    //   if (item.id == objSignature.id) {
    //     item.fontFamily = event.value;
    //   }
    // })
    // this.createContractService.contractCodePositions.next(this.listSignature);
  }

  setSizeFrameImage() {
    if(this.signConfig.signatureImage.enabled) {
      switch (this.signConfig.signaturePosition.value) {
        case 'left':
        case 'right':
          return {
            width: '370px',
            height: '136px'
          };
        case 'top':
        case 'bottom':
          return {
            width: '300px',
            height: '237px'
          };
        // "Chữ ký" bật mà chưa chọn vị trí (bật sẵn theo cấu hình DN) -> trả khung mặc định,
        // tránh trả undefined làm vỡ template ([style.width]="setSizeFrameImage().width")
        default:
          return {
            width: '300px',
            height: '136px'
          };
      }
    } else {
      return {
        width: '300px',
        height: '136px'
      };
    }
  }


  applySignatureImage(data: string) {
    // console.log(data);
    this.nameImageSignatureControl.reset();
    this.signConfigClone.isDraw.enabled = true;
    this.signConfigClone.signatureImageBase64.value = data;
    this.signConfigClone.signatureImageName.value = 'drawImage' + new Date().getTime() + '.png';
    setTimeout(() => {
      this.setFontSize(imageConfigFormPreviewId);
      this.setFontSize(imageConfigFormPreviewId);
    }, 100);
  }

  getNumber(value: any) {
    return value.split(':') || [];
  }

  setFontSize(id: string) {
    const listElement: any = document.getElementsByClassName(id);
    // console.log(listElement);
    for (const el of listElement) {
      this.setSizetext(id, el);
    }
  }

  setSizetext(id: string, el: any) {
    if (!el) {
      return;
    }
    el.style.wordBreak = 'break-word';
    if (id === imageConfigViewScaleId) {
      if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
        el = el.lastElementChild.lastElementChild as HTMLElement;
    }

    if (el) {
      let fontSize = 56;
      let minSize = 32;
      let padding = 40;
      if (id === imageConfigFormPreviewId) {
        fontSize /= 4;
        minSize /= 4;
        padding /= 4;
      }

      // console.log(el);
      el.style.fontSize = fontSize + 'px';

      let parent;
      if (this.signConfigClone.signaturePosition.value === 'top' || this.signConfigClone.signaturePosition.value === 'bottom') {
        parent = el.parentElement;
      } else {
        parent = el.parentElement.parentElement;
      }
      const parentHeight = parent.offsetHeight;
      let height = el.offsetHeight;

      while (height > parentHeight - padding && fontSize > minSize) {
        if (id === imageConfigFormPreviewId) {
          fontSize -= 1 / 4;
        } else {
          fontSize--;
        }
        el.style.fontSize = fontSize + 'px';
        height = el.offsetHeight;
      }
    }
  }

  transformContentPositionValue = transformContentPositionValue;

  checkErrorConfigDefault(): boolean {
    if(this.defaultImageConfigs){
      let errorList = [];
      for (const key in this.defaultImageConfigs) {
        if(this.defaultImageConfigs[key].isRequire && !this.signConfigClone[key].enabled && !(!this.showConfigPhone() && key == 'phoneNumber')){
          errorList.push(key);
          this.toastr.error(this.message.getMessage('config_default_image.required_error').replace('{0}', this.getName(key)));
        }
      }
      
      if(errorList.length > 0){
        return true;
      } else return false;
    }
    return false;
  }

  getName(signatureComponent: any){
    
    switch(signatureComponent){
      case 'enterpriseName':
        return this.message.getMessage('enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to');
      case 'phoneNumber':
        return this.message.getMessage('headertable.phone');
      case 'signingTime':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.signing_time');
      case 'address':
        return this.message.getMessage('headertable.address');
      case 'greenTick':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.green_tick');
      case 'position':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.position');
      case 'signatureImage':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.signatureImage');
      case 'email':
        return this.message.getMessage('config_notification.email');
    }
  }

  required(key: string, control: any = null): boolean{
    if(this.defaultImageConfigs){
      if(key == 'phoneNumber' && !this.showConfigPhone()){
        return false
      }
      return this.defaultImageConfigs[key] ? this.defaultImageConfigs[key].isRequire : false
    } else {
      return false
    }
  }

  // Quy tắc khóa checkbox theo từng thành phần (defaultImageConfigs null = TH2/DN chưa cấu hình -> không khóa):
  // - Không tick mặc định       -> disable (mặc định không hiển thị)
  // - Mặc định + không bắt buộc -> enable (KH được tick/bỏ tick)
  // - Mặc định + bắt buộc       -> disable (mặc định hiển thị, không cho bỏ tick)
  isCheckboxLocked(key: string): boolean {
    if (!this.defaultImageConfigs || !this.defaultImageConfigs[key]) {
      return false;
    }
    const conf = this.defaultImageConfigs[key];
    return !conf.isDefault || !!conf.isRequire;
  }
  
  formatCodeHTML(){
    return this.message.getMessage('enterprise_contract.image_signing.no_image.signing_time_1').replace('<i', `<span class="text-danger">*</span> <i`)
  }

  enableConfig(){
    for (const key in this.defaultImageConfigs) {
      this.signConfigClone[key].enabled = !this.showConfigPhone() && key == 'phoneNumber' ? false : this.defaultImageConfigs[key].isDefault
    }
    // Chữ ký được bật sẵn theo cấu hình DN nhưng chưa có vị trí -> set mặc định "trái".
    // Không dùng onCheckboxSignatureImageChange() vì nó là handler toggle của checkbox:
    // clone đã mang enabled=true từ signConfig nên nó rơi vào nhánh xóa trắng vị trí/tỉ lệ
    if(this.signConfigClone.signatureImage.enabled && !this.signConfigClone.signaturePosition.value){
      this.signConfigClone.signaturePosition.value = 'left';
      if(!this.signConfigClone.signatureRatio.value){
        this.signConfigClone.signatureRatio.value = '30:70';
      }
    }
  }
}

export function transformContentPositionValue(value: string){
  if(value === ContentPosition.center){
    return "center";
  }
  if(value === ContentPosition.right){
    return "flex-end";
  }
  return "flex-start";
}
